// extracted by mini-css-extract-plugin
export default {"header":"styles_header__NyX8e","headerLink":"styles_headerLink__me57E","faqActive":"styles_faqActive__VHriA","rColWrapper":"styles_rColWrapper__yg8CS"};